
import React, { Component } from 'react';
import moment  from 'moment';
import DatePicker from "react-datepicker";
import { registerLocale } from  "react-datepicker";
import ru from 'date-fns/locale/ru';
import TextField from '@material-ui/core/TextField';
import styled from 'styled-components';
import InputAdornment from '@material-ui/core/InputAdornment';
import ClearIcon from '@material-ui/icons/Clear';
import IconButton from '@material-ui/core/IconButton';

registerLocale('ru', ru);

const Wrapper = styled.div`
  .react-datepicker-wrapper {
    display: block !important;
  }
  
  .react-datepicker-popper {
    z-index: 2;
    min-width: 330px;
  }
  
  .right-position {
    left: -110px;
  }
`;


export class DateTimeWidget extends Component {

  constructor(props) {
    super(props);

    this.inputRef = React.createRef();
  }

  handleChange = (value) => {
    const { onChange } = this.props;
    let stringValue = null;

    if (value) {
      stringValue = moment(value).format('YYYY-MM-DD HH:mm');
      onChange(value, stringValue);
    }
    else {
      onChange(null, null);
    }
  };

  clearValue = () => {
    const { onChange } = this.props;
    onChange(null, null);
  };

  handleCalendarClose = () => {
    const { onCalendarClose } = this.props;
    if (onCalendarClose) {
      onCalendarClose();
    }
  };

  parseDate = (value) => {
    if (value && moment(value).isValid()) {
      return  moment(value).toDate();
    }
  }

  render() {
    let { value, size, label, popperPlacement, minDate, openToDate, disabled } = this.props;
    let widgetDateValue = null;

    if (value && moment(value).isValid()) {
      widgetDateValue = moment(value).toDate();
    }

    const MaterialInput = ({ value, onClick }) => (
      <TextField
        onClick={onClick}
        value={value}
        label={label}
        size={size}
        disabled={disabled}
        fullWidth={true}
        variant="outlined"
        inputRef={this.inputRef}
        InputProps={{
          endAdornment: (
            <>
              {!disabled && (
                <InputAdornment position="end">
                  <IconButton onClick={() => this.clearValue()} disabled={widgetDateValue === null} size={'small'}>
                    <ClearIcon />
                  </IconButton>
                </InputAdornment>
              )}
            </>
          )
        }}
      />
    );

    return (
      <Wrapper>
        <DatePicker
          selected={widgetDateValue}
          onChange={date => this.handleChange(date)}
          onCalendarClose={() => this.handleCalendarClose()}
          customInput={<MaterialInput />}
          customInputRef={this.inputRef}
          locale="ru"
          showTimeSelect
          timeIntervals={60}
          showPopperArrow={false}
          dateFormat="dd.MM.yyyy HH:mm"
          timeCaption="Время"
          timeFormat="HH:mm"
          popperPlacement={popperPlacement}
          disabled={disabled}
          minDate={this.parseDate(minDate)}
          openToDate={openToDate}
        />
      </Wrapper>
    )
  }
}
